import type { ReactElement } from 'react';

import { relationLabel } from '../presentation';
import { useDocumentImpact } from '../use-relations';
import { skeletonLine } from '@/components/ui/skeleton';

// Panorama de impacto al iniciar una modificación (spec §6.2.6): los documentos
// relacionados que podrían requerir revisión. Es informativo: no bloquea; el
// responsable decide si el cambio los afecta.

export function ImpactPanorama({ entryId }: { entryId: string }): ReactElement | null {
  const impact = useDocumentImpact(entryId, true);
  if (impact.isError) {
    return (
      <p className="soft" style={{ fontSize: 12.5, marginTop: 10 }}>
        No se pudo cargar el panorama de documentos relacionados.
      </p>
    );
  }
  if (impact.isLoading) {
    return (
      <div aria-busy="true" aria-label="Cargando documentos relacionados" style={{ marginTop: 10 }}>
        <div className={skeletonLine({ width: 70 })} />
      </div>
    );
  }
  const rows = impact.data ?? [];
  if (rows.length === 0) {
    return null;
  }
  return (
    <div style={{ marginTop: 10 }}>
      <p style={{ margin: '0 0 6px' }}>
        Revisa si estos documentos relacionados también requieren cambios:
      </p>
      <ul className="rel-list">
        {rows.map((r) => (
          <li key={`${r.direction}-${r.entryId}`} className="rel-item">
            <div className="rel-main">
              <span className="code">{r.code}</span> {r.title ?? ''}
              <div className="soft" style={{ fontSize: 12 }}>
                {relationLabel(r)}
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
